module.exports = __webpack_public_path__ + "img/851-72c14a.png";